(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newcollection-grid"] && !Shopify.designMode) return;
  try {
    
if (typeof Swiper !== 'undefined') {
  new Swiper('.new-collections-swiper', {
    slidesPerView: 4,
    spaceBetween: 24,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: { slidesPerView: 1.3 },
      640: { slidesPerView: 2 },
      1024: { slidesPerView: 4 }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
